// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes, ReduxStore, ReduxNext, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { ChooseVehiclePendoUser } from '../types/pendo.types';
import {
    getBridgeUserFullName,
    getBridgeUserId,
    getCommonOrgId,
    getDealerName,
    getDealXgId
} from '../selectors/chooseVehicleAppSelectors';

export const initializePendo = (pendoObj: ChooseVehiclePendoUser, updateDxgIdNode = false) => {
    try {
        window.pendo.initialize({
            visitor: {
                id: pendoObj.bridgeId,
                full_name: pendoObj.fullName,
                ...(updateDxgIdNode && { dc_dealXgId: pendoObj.dealXgId })
            },
            account: {
                id: pendoObj.accountId ? `${pendoObj.accountId}` : 'dc_choosevehicle',
                dc_dealerName: pendoObj.dealerName,
                ...(!updateDxgIdNode && { dc_dealXgId: pendoObj.dealXgId })
            }
        });
    } catch (error) {
        console.error('Failed to initialize Pendo:', error);
    }
};

export const postBootstrapMiddleware = (store: ReduxStore<any>) => (next: ReduxNext) => async (action: AnyFSA) => {
    // need reducers to execute first so that we can use the state that's updated by INIT_PENCIL_SUCCESS
    const nextResult = next(action);

    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
            // here will create the request object for Pendo Dashboard
            const state = store.getState();
            const bridgeId = getBridgeUserId(state);
            const commonOrgId = getCommonOrgId(state);
            const fullName = getBridgeUserFullName(state);
            const dealXgId = getDealXgId(state);
            const dealerName = getDealerName(state);
            const updateDxgIdNode = featureToggleSelectors.isEnableUpdatePendoMetadata(state);

            const pendoObj: ChooseVehiclePendoUser = {
                accountId: commonOrgId,
                bridgeId,
                fullName,
                dealXgId,
                dealerName
            };

            initializePendo(pendoObj, updateDxgIdNode);
            break;
        }
    }

    return nextResult;
};
